import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import ItemList from '../ItemList/ItemList.jsx'
import NabSubBar from '../NabSubBar/NabSubBar'
import { categoriesAPI } from '../../config/api'

const ItemListContainer = ({ welcomeText }) => {
    const [products, setProducts] = useState([])
    const [pagination, setPagination] = useState({})
    const [currentPage, setCurrentPage] = useState(1)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)
    const { categoryId } = useParams()

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                setLoading(true)
                setError(null)

                const data = await categoriesAPI.getProductsByCategory(
                    categoryId, 
                    currentPage, 
                    10
                )

                if (data.status === "success") {
                    const rawProducts = Array.isArray(data?.data?.products)
                        ? data.data.products
                        : Array.isArray(data?.products)
                            ? data.products
                            : []

                    const transformedProducts = rawProducts.map(product => ({
                        id: product.clave,
                        name: product.nombre,
                        description: product.descripcion_corta,
                        price: product.precioVenta,
                        thumbnails: product.imagen ? [product.imagen] : [],
                        code: product.clave,
                        stock: product.existencia,
                        category: product.categoria
                    }))

                    setProducts(transformedProducts)
                    setPagination(data?.data?.pagination || data?.pagination || {})
                }
            } catch (error) {
                console.error('Error fetching products:', error)
                setError('Error al cargar productos')
            } finally {
                setLoading(false)
            }
        }

        fetchProducts()
    }, [categoryId, currentPage])

    if (loading) return <div className="text-center p-5">Cargando...</div>
    if (error) return <div className="alert alert-danger">{error}</div>

    return (
        <div>
            <NabSubBar />
            <label className="ps-3">
                <input id="searchText" type="search" className="form-control" 
                       placeholder="Busqueda por nombre" required />
            </label>
            <button id="btnSearch" type="button" className="mpk_button_primary">
                Buscar
            </button>
            <button id="btnClearFilter" type="button" className="mpk_button_secondary">
                Quitar Filtro
            </button>
            <div className="row m-auto">
                <div className="col-sm text-center">
                    <ItemList products={products} />
                </div>
            </div>

            {/* Paginación */}
            {pagination.totalPages > 1 && (
                <div className="pagination-container text-center my-4">
                    <button 
                        className="mpk_button_secondary mx-1"
                        onClick={() => setCurrentPage(p => p - 1)}
                        disabled={!pagination.hasPrevPage}
                    >
                        Anterior
                    </button>

                    {pagination.pageNumbers?.map((pageNum) => (
                        <button
                            key={pageNum}
                            className={`mpk_button_${currentPage === pageNum ? 'primary' : 'secondary'} mx-1`}
                            onClick={() => setCurrentPage(pageNum)}
                        >
                            {pageNum}
                        </button>
                    ))}

                    <button 
                        className="mpk_button_secondary mx-1"
                        onClick={() => setCurrentPage(p => p + 1)}
                        disabled={!pagination.hasNextPage}
                    >
                        Siguiente
                    </button>

                    <span className="ms-3">
                        Página {pagination.page} de {pagination.totalPages}
                    </span>
                </div>
            )}
        </div>
    )
}

export default ItemListContainer